import React from "react";
import { OrderProductListProps } from "../utils/types";
import CommonTable from "src/business-types/grocery/components/CommonTable";

interface ProductTableData {
  id: string | number;
  sno: number;
  name: string;
  car: string;
  qty: string | number;
  price: string | number;
}

const OrderProductList: React.FC<OrderProductListProps> = ({ order }) => {
  const tableData: ProductTableData[] = React.useMemo(() => {
    if (!order?.cars?.length) {
      // Fallback to Products array if cars array is empty
      if (order?.Products?.length) {
        return order.Products.map((product, index) => ({
          id: product.id || index,
          sno: index + 1,
          name: product.name || "N/A",
          car: "N/A", // No car info in Products array
          qty: product.quantity || 1,
          price: product.amount || product.totalPrice || 0,
        }));
      }
      return [];
    }

    let globalIndex = 0;

    return order.cars.flatMap((carProduct, carIndex) => {
      // Use services array which contains objects with productDetails
      const services = carProduct.services || [];
      
      return services.flatMap((service, serviceIndex) => {
        // Check if service has productDetails array
        const productDetails = service?.productDetails || [];
        
        return productDetails.map((product: { product: any; name: any; Quantity: any; quantity: any; price: any; amount: any; }, productIndex: any) => {
          globalIndex += 1;
          return {
            id: `${carIndex}-${serviceIndex}-${productIndex}`,
            sno: globalIndex,
            name: product?.product || product?.name || "N/A",
            car: carProduct.carNumber || service?.carNumber || "N/A",
            qty: product.Quantity || product.quantity || 1,
            price: product.price || product.amount || 0,
          };
        });
      });
    });
  }, [order?.cars, order?.Products]);

  const headCells = [
    { id: "sno" as keyof ProductTableData, label: "S.No", align: "center" as const, sorting: false },
    { id: "name" as keyof ProductTableData, label: "Product Name", align: "left" as const, sorting: false },
    { id: "car" as keyof ProductTableData, label: "Car Numbers", align: "center" as const, sorting: false },
    { id: "qty" as keyof ProductTableData, label: "Quantity", align: "center" as const, sorting: false },
    { id: "price" as keyof ProductTableData, label: "Total (QAR)", align: "right" as const, sorting: false },
  ];

  console.log("Order data for debugging:", order);
  console.log("Table data:", tableData);

  return (
    <div className="order-product-container h-full flex flex-col">
      <CommonTable<ProductTableData>
        data={tableData}
        headCells={headCells}
        title="Order Products"
        selectable={false}
        denseToggle={false}
        showToolbar={false}
        pagenation={true}
        pageSize={5}
        showFilterIcon={false}
        Action={false}
        shortByTable={false}
        className="compact-table h-full"
      />
    </div>
  );
};

export default OrderProductList;